
/** Returns the given number, as string, with thousand seperators
 * Note: For presentation purposes it skips formatting until >= 10.000
 */
export const formatNumber = (number) => {
  if (number !== null || number !== undefined) {
    if (number > 9999) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  }

  return number;
};